<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        {{ title }}
      </p>
    </header>
    <div class="card-image">
      <figure class="image is-four-fifths">
        <img :src="imageUrl" alt="Placeholder image">
      </figure>
    </div>
    <div class="card-content">
      <div class="content">
        <p v-html="displayBody"></p>
      </div>
      <br>
      <time>{{ displayDate }}</time>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    title: {
      required: true,
      type: String
    },
    description: {
      required: false,
      type: String
    },
    imageUrl: {
      required: true,
      type: String
    },
    body: {
      required: true,
      type: String
    },
    date: {
      required: true,
      type: String
    }
  },
  computed: {
    displayDate () {
      return moment(this.date).format('YYYY-MM-DD hh:mm')
    },
    displayBody () {
      return this.body.replace(/(?:\r\n|\r|\n)/g, '<br />')
    }
  }
}
</script>

<style scoped>
  header {
    margin-bottom: 1px;
  }
  .card-image {
    max-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PostListItem.vue